import GenericDB from './generic-db'

export default class StripeCustomersDB extends GenericDB {
  constructor() {
    super(`/stripe_customers`)
  }
}
